import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';

import { BaasToepassingService } from '@lvflanders/bar';
import { BaasTileList, BaasTileOptions, BarI18nPipe } from '@lvflanders/bar-ng-ui';

import { HoedanigheidpickerDto } from '../../api/models';
import { HoedanigheidpickerDialogData } from '../../models/v2/hoedanigheidpicker-dialog-data.type';

@Component({
    selector: 'startscherm-hoedanigheid-dialog',
    templateUrl: './startscherm-hoedanigheid-dialog.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatDialogTitle, MatDialogContent, BaasTileList, BarI18nPipe]
})
export class StartschermHoedanigheidDialog {
    readonly #dialogRef = inject(MatDialogRef<StartschermHoedanigheidDialog>);
    readonly #data = inject<HoedanigheidpickerDialogData>(MAT_DIALOG_DATA);
    readonly #toepassing = inject(BaasToepassingService);

    protected readonly tiles = computed<BaasTileOptions[]>(() => {
        if (this.#data.clients) {
            return this.#data.clients.map((client): BaasTileOptions => {
                return {
                    hideFavoriteIndicator: true,
                    content: `${client.rolcodeOmschrijving == null || client.rolcodeOmschrijving == undefined ? '' : client.rolcodeOmschrijving} ${client.naam}`,
                    action: () => this.#hoedanigheidSelected(client),
                    initiator: true
                };
            });
        }
        return [];
    });

    async #hoedanigheidSelected(hoedanigheid: HoedanigheidpickerDto): Promise<void> {
        await this.#toepassing.setHoedanigheid(hoedanigheid.hoedanigheid ?? '', hoedanigheid.hoedanigheidRolcode ?? '');
        if (this.#data.noNavigation) {
            if (this.#data.doReset) {
                this.#dialogRef.close({ client: hoedanigheid, reset: this.#data.doReset });
            } else {
                this.#dialogRef.close({ client: hoedanigheid, reset: this.#data.doReset });
            }
        } else {
            window.location.reload();
        }
    }
}
